import React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "../../UI/Table";
import { useSortableTable } from "../../../hooks/useSortableTable";

const RegistrationPackagesTab = ({ data }) => {
  const { registrationPackages } = data;

  const {
    sortedData: sortedRequests,
    handleSort,
    getSortIndicator,
  } = useSortableTable(registrationPackages);

  const tableHeaders = [
    { key: "name", label: "Name", sortable: true },
    { key: "cost", label: "Cost", sortable: true },
    { key: "number_available", label: "Available", sortable: true },
    { key: "number_spots", label: "Spots", sortable: true },
  ];

  if (sortedRequests.length === 0) {
    return (
      <div className="tab-content">
        <h3>Registration Packages</h3>
        <div className="tab-empty">No registration packages found.</div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <h3>Registration Packages</h3>
      <Table>
        <TableHeader>
          {tableHeaders.map((header, index) => (
            <TableCell
              key={index}
              header
              onClick={
                header.sortable ? () => handleSort(header.key) : undefined
              }
              style={{
                cursor: header.sortable ? "pointer" : "default",
                userSelect: "none",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {header.label}
                {header.sortable && getSortIndicator(header.key)}
              </div>
            </TableCell>
          ))}
        </TableHeader>
        <TableBody>
          {sortedRequests.map((pkg) => (
            <TableRow key={pkg.id}>
              <TableCell>
                <strong>{pkg.name}</strong>
              </TableCell>
              <TableCell className="row__amount">
                $
                {pkg.cost.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </TableCell>
              <TableCell>
                {pkg.number_available?.toLocaleString() || "N/A"}
              </TableCell>
              <TableCell>
                {pkg.number_spots?.toLocaleString() || "N/A"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default RegistrationPackagesTab;
